/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Typography,
  Stack,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Paper
} from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, useNavigate } from 'react-router-dom';
import ContentLoader from '../../utils/errorPages/ContentLoader';
import PaymentAction from '../../store/actions/PaymentAction';

function ManualTransactionView() {
  const [payInfo, setPayInfo] = useState({});
  const { code } = useParams();
  const { manualItemData, isLoading } = useSelector((state) => state.payment);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(PaymentAction.getManualPaymentItem(code));
  }, [dispatch]);

  useEffect(() => {
    if (manualItemData) {
      setPayInfo(manualItemData);
    }
  }, [manualItemData]);

  console.log(manualItemData, 'manualItemData');
  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      {isLoading ? <ContentLoader /> : ''}
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/transaction/manual">
            Manual Transactions
          </Typography>
          <Typography component="h2" variant="h2">
            / View
          </Typography>
        </Stack>
      </div>
      <Card>
        <CardHeader title="Transaction Details" />
        <Grid container spacing={1}>
          <Grid item md={7} lg={7} xl={8}>
            <CardContent>
              <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={2} component="th">
                          Client Details
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th">Client Name</TableCell>
                        <TableCell component="td">{payInfo?.client?.name || ''}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Client Mail</TableCell>
                        <TableCell component="td">{payInfo?.client?.email || ''}</TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={2} component="th">
                          Invoice Details
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th">Invoice Number</TableCell>
                        <TableCell component="td">
                          {payInfo?.invoice?.invoice_number || ''}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Invoice Date</TableCell>
                        <TableCell component="td">{payInfo?.invoice?.invoice_date || ''}</TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={2} component="th">
                          Payment Details
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th">Payment Gateway</TableCell>
                        <TableCell component="td" sx={{ textTransform: 'capitalize' }}>
                          {payInfo?.payment_gateway || ''}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Transaction ID</TableCell>
                        <TableCell component="td">{payInfo?.transaction_id || ''}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Amount</TableCell>
                        <TableCell component="td">
                          {`${payInfo?.short_name} ${payInfo?.amount || ''}`}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Message</TableCell>
                        <TableCell component="td">{payInfo?.message || ''}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </CardContent>
          </Grid>
          <Grid item md={5} lg={5} xl={4}>
            <CardContent sx={{ pl: '0px!important' }}>
              <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={2} component="th">
                          Status Details
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th">Paid Date</TableCell>
                        <TableCell component="td">{payInfo?._created_at}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Payment Type Status</TableCell>
                        <TableCell component="td">{payInfo?.payment_type_status || ''}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Transaction Status</TableCell>
                        <TableCell component="td">
                          <Chip color="success" label={payInfo?.status || ''} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              {payInfo?.updateLog && payInfo?.updateLog.length > 0 && (
                <Card sx={{ mt: 2, border: '1px solid rgba(44, 58, 73, 0.15)' }}>
                  <CardHeader title="Reason for Update" />
                  <CardContent sx={{ p: '0!important' }}>
                    <Timeline
                      sx={{
                        [`& .${timelineItemClasses.root}:before`]: {
                          flex: 0,
                          padding: 0
                        }
                      }}
                    >
                      {payInfo?.updateLog.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <TimelineItem>
                              <TimelineSeparator>
                                <TimelineDot
                                  sx={{
                                    backgroundColor: item.color,
                                    boxShadow: '0 0 0 0.1875rem rgba(115,103,240,.16)'
                                  }}
                                />
                                {payInfo?.updateLog.length !== index + 1 ? (
                                  <TimelineConnector />
                                ) : (
                                  ''
                                )}
                              </TimelineSeparator>
                              <TimelineContent sx={{ py: 0 }}>
                                <ListItem
                                  sx={{ p: 0, pr: '120px' }}
                                  disableGutters
                                  secondaryAction={
                                    <Chip
                                      size="small"
                                      label={item._created_at}
                                      color="primary"
                                      icon={<AccessTimeIcon sx={{ fontSize: '14px !important' }} />}
                                      variant="contained"
                                      sx={{
                                        borderRadius: '16px',
                                        mb: 1,
                                        '.MuiChip-label': {
                                          fontSize: '12px',
                                          fontWeight: '700 !important',
                                          opacity: '1'
                                        }
                                      }}
                                    />
                                  }
                                >
                                  <ListItemText
                                    sx={{
                                      maxWidth: '250px',
                                      wordBreak: 'break-word'
                                    }}
                                    primary={
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontWeight: '700 !important',
                                          maxWidth: '250px',
                                          wordBreak: 'break-word'
                                        }}
                                        dangerouslySetInnerHTML={{ __html: item.reason }}
                                      />
                                    }
                                    secondary={
                                      <>
                                        <Typography
                                          sx={{ display: 'inline' }}
                                          component="span"
                                          variant="body2"
                                          color="text.primary"
                                        >
                                          Updated by
                                        </Typography>
                                        {`: ${item.name}`}
                                        <br />
                                        <Typography
                                          sx={{ display: 'inline' }}
                                          component="span"
                                          variant="body2"
                                          color="text.primary"
                                        >
                                          Mail
                                        </Typography>
                                        {`: ${item.email}`}
                                      </>
                                    }
                                  />
                                </ListItem>
                              </TimelineContent>
                            </TimelineItem>
                          </React.Fragment>
                        );
                      })}
                    </Timeline>
                  </CardContent>
                </Card>
              )}
            </CardContent>
          </Grid>
        </Grid>
        <CardActions sx={{ justifyContent: 'center', p: 3 }}>
          <Button
            type="button"
            className="cancel__btn"
            // fullWidth
            sx={{ mt: 2 }}
            variant="contained"
            color="primary"
            size="medium"
            onClick={() => {
              navigate('/transaction/manual');
            }}
          >
            Back
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
}
export default ManualTransactionView;
